import { SortOrder } from './types.js';
/** Options are the same entry when they stand for the same value; the label may differ by formatter. */
export const areOptionsEqual = (a, b) => a.value === b.value;
/**
 * What a bulk removal leaves behind. A fixed option survives it: the list is not what decides whether
 * it belongs, which is also why its row offers no remove button of its own.
 */
export const keepAfterBulkRemove = (selected, removed) => selected.filter((option) => option.fixed || !removed.some((item) => areOptionsEqual(option, item)));
/**
 * The options in `sortOrder`: by `compareOptions` when given, else alphabetically by the label `getSortLabel` reads for
 * each of them.
 */
export const sortOptions = (options, sortOrder, getSortLabel, compareOptions) => {
    const labelledOptions = options.map((option) => ({ option, sortLabel: getSortLabel(option) }));
    const compareAscending = (a, b) => compareOptions ? compareOptions(a.option, b.option) : a.sortLabel.localeCompare(b.sortLabel);
    return labelledOptions
        .sort((a, b) => (sortOrder === SortOrder.ASC ? compareAscending(a, b) : compareAscending(b, a)))
        .map(({ option }) => option);
};
